import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiPledges() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "setup/";
  return {
    GetPledges: () => authAxios.get(url + "GetPledges/"),
    AddPledge: (record) => authAxios.post(url + "AddPledge/", record),
    GetUpdatePledge: (id) => authAxios.get(url + "EditPledge/" + id),
    SaveUpdatePledge: (record) => authAxios.post(url + "EditPledge/", record),
    GetAmeerTanzeemName: () => authAxios.get(url + "GetAmeerTanzeemName/"),
    Delete: (id) => authAxios.delete(url + "DeletePledge/" + id),
  };
}
